export default {
  SAC_1: {
    title: 'Transitions by Service Status',
    description: 'Table with total transitions made between service statuses in the selected time period.',
  },
  SAC_2: {
    title: 'Proprietary Posts Timeline',
    description: 'Date-sorted list (most recent) of posts made by registered profiles (includes posts and interactions made by pages).',
  },
  SAC_3: {
    title: 'Received Engagement',
    description: 'Sum of all engagement actions received from proprietary posts filtered in the research.',
  },
  SAC_4: {
    title: 'Received Likes',
    description: 'Sum of all likes received from proprietary posts filtered in the research.',
  },
  SAC_5: {
    title: 'Received Comments',
    description: 'Sum of all comments received from proprietary posts in the selected period filtered in the research.',
    info: {
      title: 'Why is this number different from Proprietary Metrics?',
      intro: 'This component sums the comments of your brand\'s posts — Proprietary posts, Story and Reels — across all networks connected to the research. Proprietary Metrics show one network at a time, such as Instagram.',
      type: 'Two filters also change the result: Interactions set to "Indifferent" includes third-party interactions, such as mentions.',
      status: 'Status applies to care items. Using it, even with "Select all", removes your brand\'s posts from the sum.',
      compare: 'To compare the two numbers, use the same period, the same page and the same social network. Leave Status unselected and, in Interactions, select only Proprietary posts, Story and Reels.',
    },
  },
  SAC_6: {
    title: 'Posts and Interactions',
    description: 'Count of posts from connected pages filtered in the research. Shows proprietary posts by default, but can be adjusted to show all interaction types.',
  },
  SAC_7: {
    title: 'Impressions',
    description: 'Sum of total organic and paid impressions from proprietary posts filtered in the research.',
  },
  SAC_8: {
    title: 'Reach',
    description: 'Sum of total reach achieved from proprietary posts filtered in the research.',
  },
  SAC_9: {
    title: 'Views',
    description: 'Sum of video views on proprietary channels in the research.',
  },
  SAC_10: {
    title: 'Impressions Over Time',
    description: 'Sum of total impressions from proprietary posts filtered in the research, displayed over the selected time period. On Instagram, only Stories return this data, due to a Meta limitation.',
  },
  SAC_11: {
    title: 'Reach Over Time',
    description: 'Sum of total reach from proprietary posts filtered in the research, displayed over the selected time period.',
  },
  SAC_12: {
    title: 'Received Engagement Over Time',
    description: 'Sum of all engagement actions received from proprietary posts filtered in the research, displayed over the selected time period.',
  },
  SAC_13: {
    title: 'Posts with Most Engagement',
    description: 'List cards containing proprietary content ordered by total engagement achieved.',
  },
  SAC_14: {
    title: 'Interaction Sentiment Over Time',
    description: 'Distribution of received interactions by polarity over a time period.',
  },
  SAC_15: {
    title: 'Interaction Sentiment Gauge',
    description: 'Represents the result of the equation: (positive posts / collected posts * 100) - (negative posts / collected posts * 100), applied only to received interactions.',
  },
  SAC_16: {
    title: 'Engagement by Channel Over Time',
    description: 'Distribution of received interactions divided by proprietary channel over a time period.',
  },
  SAC_17: {
    title: 'Interacting Users',
    description: 'Count of unique users who interacted with proprietary channels.',
  },
  SAC_18: {
    title: 'Sentiment by Proprietary Channel',
    description: 'Distribution of posts (posts + interactions) by proprietary channels and their polarity breakdown.',
  },
  SAC_19: {
    title: 'Sentiment by Proprietary Tag',
    description: 'Distribution of posts (posts + interactions) by assigned tags and their polarity breakdown.',
  },
  SAC_20: {
    title: 'Interaction Sentiment by Gender',
    description: 'Distribution of interactions by gender and their polarity breakdown.',
  },
  SAC_21: {
    title: 'Sentiment by Themes',
    description: 'Distribution of posts (posts + interactions) by research themes and their polarity breakdown.',
  },
  SAC_22: {
    title: 'Interaction Sentiment Distribution',
    description: 'Division of interactions by positive, negative, or neutral polarity.',
  },
  SAC_23: {
    title: 'Most Commented Proprietary Posts',
    description: 'Carousel cards containing proprietary content ordered by total comments received.',
  },
  SAC_24: {
    title: 'Interactions by Channel',
    description: 'Distribution of received interaction volume divided by proprietary channel.',
  },
  SAC_25: {
    title: 'Interactions per User',
    description: 'Ratio of the number of interactions divided by the number of interacting users.',
  },
  SAC_26: {
    title: 'Interaction Sentiment Over Time (Percentage)',
    description: 'Distribution of received interactions by percentage proportion of positive, negative, and neutral over a time period.',
  },
  SAC_27: {
    title: 'Services by Operators',
    description: 'Percentage distribution of service sessions handled by each operator.',
  },
  SAC_28: {
    title: 'Users with More than 1 Interaction',
    description: 'Total number of users who interacted more than once with proprietary content.',
  },
  SAC_29: {
    title: 'Distribution by Theme (Proprietary)',
    description: 'Volume of posts or interactions on proprietary profiles distributed by themes registered in the research.',
  },
  SAC_30: {
    title: 'Distribution by Tag (Proprietary)',
    description: 'Volume of posts or interactions on proprietary profiles distributed by assigned tags.',
  },
  SAC_31: {
    title: 'Total Fans',
    description: 'Total fans of the selected pages on the final date of the researched period.',
  },
  SAC_32: {
    title: 'New Fans',
    description: 'Total fans gained by the selected pages in the researched period.',
  },
  SAC_33: {
    title: 'Fan Base Evolution',
    description: 'Daily variation of fans of the researched pages in the period, relative to the previous day.',
  },
  SAC_34: {
    title: 'Engagement Matrix by Posts',
    description: 'Compares engagement, impressions, and sentiment index of comments on proprietary posts. Quadrant divisions are based on the arithmetic average of the last 90 days.',
  },
  SAC_35: {
    title: 'Engagement Matrix by Tags',
    description: 'Compares engagement, impressions, and sentiment index of post comments by tag. Quadrant divisions are based on the arithmetic average of the last 90 days.',
  },
  SAC_36: {
    title: 'Service Volume by Operator',
    description: 'Total events counted between "Old Status" and "New Status", filtered by operator. Does not count new pending conversations without a status change yet.',
  },
  SAC_37: {
    title: 'Service Volume by Page',
    description: 'Total events counted between "Old Status" and "New Status", filtered by page. Does not count new pending conversations without a status change yet.',
  },
  SAC_38: {
    title: 'Service Volume Over Time',
    description: 'Total events counted between "Old Status" and "New Status", filtered by time. Does not count new pending conversations without a status change yet.',
  },
  SAC_39: {
    title: 'Total Services',
    description: 'Total events counted between "Old Status" and "New Status" filtered in the research. (Note: Does not count new pending conversations where no status change has occurred yet.)',
  },
  SAC_40: {
    title: 'Average Service Time by Operator',
    description: 'Average time elapsed between "Old Status" and "New Status" filtered in the research, by operator.',
  },
  SAC_41: {
    title: 'Average Service Time by Page',
    description: 'Average time elapsed between "Old Status" and "New Status" filtered in the research, by page.',
  },
  SAC_42: {
    title: 'Average Service Time Over Time',
    description: 'Average time elapsed between "Old Status" and "New Status" filtered in the research, over time.',
  },
  SAC_43: {
    title: 'Total Average Service Time',
    description: 'Average time elapsed between "Old Status" and "New Status" filtered in the research.',
  },
  SAC_44: {
    title: 'Services by Operators Over Time',
  },
  SAC_45: {
    title: 'Operators Report',
    description: 'Operators log report.',
  },
  SAC_46: {
    title: 'Productivity Report',
    description: 'Productivity report.',
  },
  SAC_47: {
    title: 'Backlog Table',
    description: 'Table of the oldest open cases.',
  },
  SAC_48: {
    title: 'SLA',
    description: 'Conversations responded within SLA.',
  },
  SAC_49: {
    title: 'Productivity',
    description: 'Performance metric for services carried out by operators relative to received cases. Represents the result of the equation (total services / total received cases * 100).',
  },
  SAC_50: {
    title: 'Productivity by Day',
    description: 'Distribution of the productivity index per day over time. Measures the performance of services carried out by operators relative to received cases.',
  },
  SAC_51: {
    title: 'Received vs. Attended Service Volume',
    description: 'Number of received service sessions compared to attended ones over time.',
  },
  SAC_52: {
    title: 'Operator Status',
    description: 'Table showing the service status of all operators.',
  },
  SAC_53: {
    title: 'Consolidated Ratings',
    description: 'Displays customer satisfaction survey results by sentiment.',
  },
  SAC_54: {
    title: 'Ratings Over Time',
    description: 'Displays customer satisfaction survey results.',
  },
  SAC_55: {
    title: 'Service Ratings',
    description: 'Table with service ratings made via Smartcare.',
  },
  SAC_56: {
    title: 'Lovers Table',
    description: 'Table of most engaged users.',
  },
  SAC_57: {
    title: 'Lovers Interests',
    description: 'Distribution of interests found in user posts.',
  },
  SAC_58: {
    title: 'Average Service Time',
    description: 'Time spent in each conversation status.',
  },
  SAC_59: {
    title: 'User Performance Matrix',
    description: 'User performance matrix, detailing the working hours of each operator.',
  },
  SAC_60: {
    title: 'Service Count by Channel',
    description: 'Table with service count divided by channels.',
  },
  SAC_61: {
    title: 'Posts by Tag',
    description: 'Distribution of posts by assigned tags for proprietary data.',
  },
  SAC_62: {
    title: 'Posts by Tag Over Time',
    description: 'Distribution of posts by tags assigned in the research over time.',
  },
  SAC_63: {
    title: 'Interactions Over Time',
    description: 'Linear distribution of collected interactions over a time period.',
  },
  SAC_64: {
    title: 'Posts by Tag',
    description: 'Distribution of posts by assigned tags.',
  },
  SAC_65: {
    title: 'Post Sampling Projection',
    description: 'Projection of the volume of posts collected in the researched period, considering post sampling.',
  },
  SAC_66: {
    title: 'Google My Business Ratings',
    description: 'Number of ratings by star value in the Google My Business channel.',
  },
  SAC_67: {
    title: 'Interactions routed over time',
    description: 'Distribution of interactions by routing setting over time.',
  },
};
